var selector = document.getElementById("datepicker");

if (selector) {
    var im = new Inputmask({'alias': 'datetime', 'inputFormat': 'yyyy-mm-dd', 'placeholder': 'yyyy-mm-dd'});
    im.mask(selector);
}

var menuItems = document.getElementsByClassName('item_menu');

for (var i = 0; i < menuItems.length; i++) {
    if (menuItems[i].getElementsByTagName('ul')[0]) {
        menuItems[i].classList.add('has_submenu');
    }
}

if (screen.width < 1040) {
    document.body.classList.add('miniSideleft');
}

var searchInput = document.getElementById('search_inp');

if (searchInput) {
    var searchin = searchInput.value;

    if (searchin !== '' && searchin !== 'Поиск по сайту') {
        searchInput.classList.add('withsearch');
    }
}

var speed = 500,
    b = document.getElementsByClassName('banner-battle')[0],
    windowheight = 300,
    showBanner = true,
    contentTable = document.getElementsByClassName('content-table')[0];

if (b) {
    var close = b.getElementsByClassName('close')[0];
    if (close) {
        close.addEventListener('click', function () {
            b.style.display = 'none';
            showBanner = false;
        });
    }
}

function show_scrollTop() {
    if (!b) {
        return;
    }

    if (window.pageYOffset > windowheight && window.screen.width > 1000 && showBanner) {
        b.style.display = 'block';
    } else {
        b.style.display = 'none';
    }
}


window.addEventListener('scroll', function () {
    show_scrollTop();
    fixedBanner();
});

show_scrollTop();

function floatBanner() {
    var floatBanner = document.getElementsByClassName('float-banner')[0];
    var secondFix = document.getElementsByClassName('second-fix')[0];
    var banner = document.getElementsByClassName('banner')[0];

    if (!floatBanner || !secondFix || !banner) {
        return false;
    }

    floatBanner.style.right = (floatBanner.width - 980) / 2 - 240;
    secondFix.style.right = (secondFix.width - 980) / 2 - 300;
    secondFix.style.display = 'block';
}

function fixedBanner() {
    var elem = document.querySelector('.float-banner');

    if (elem) {
        var canFixed = elem.classList.contains('can-fixed');

        if (elem.length && canFixed && window.pageYOffset > 375) {
            elem.classList.add('fixed');
        } else {
            elem.classList.remove('fixed');
        }
    }
}

floatBanner();

window.addEventListener('resize', function () {
    floatBanner();
    show_scrollTop()
});

var menuBar = document.querySelector('.menu-bar');
menuBar.addEventListener('click', function (event) {
    event.preventDefault();
    document.querySelector('body').classList.add('menu-active');
});

var closeMenuBurger = document.querySelector('.close-menu-burger');
closeMenuBurger.addEventListener('click', function (event) {
    event.preventDefault();
    document.querySelector('body').classList.remove('menu-active');
});

var mobileArrow = document.querySelectorAll('.mobile-arrow');

for (var propMobileArrow in mobileArrow) {
    if (!mobileArrow.hasOwnProperty(propMobileArrow)) {
        continue;
    }

    var elementMobileArrow = mobileArrow[propMobileArrow];

    elementMobileArrow.addEventListener('click', function (event) {
        var linkBack = document.createElement('div');
        linkBack.innerHTML = 'Вернуться назад';
        linkBack.classList.add('link-back');

        this.nextElementSibling.appendChild(linkBack);
        this.parentElement.querySelector('.sf-menu').classList.add('fixed');

        this.parentElement.classList.add('parent-fixed');

        linkBack.addEventListener('click', function (event) {
            this.parentElement.classList.remove('fixed');
            this.parentElement.parentElement.classList.remove('parent-fixed');
            this.remove();
        })
    });
}

function initPreventIosScroll(element) {
    if (!element.length) {
        return;
    }

    for (var i = 0; i < element.length; i++) {
        var overlay = element[i];
        var _clientY = 0;

        overlay.addEventListener('touchstart', function (event) {
            if (event.targetTouches.length === 1) {
                _clientY = event.targetTouches[0].clientY;
            }
        }, false);

        overlay.addEventListener('touchmove', function (event) {
            if (event.targetTouches.length === 1) {
                disableRubberBand(event, overlay);
            }
        }, false);

        function disableRubberBand(event, currentOverlay) {
            var clientY = event.targetTouches[0].clientY - _clientY;

            if (currentOverlay.scrollTop === 0 && clientY > 0 && event.cancelable) {
                event.preventDefault();
            }

            if (isOverlayTotallyScrolled(currentOverlay) && clientY < 0 && event.cancelable) {
                event.preventDefault();
            }
        }

        function isOverlayTotallyScrolled(currentOverlay) {
            return currentOverlay.scrollHeight - currentOverlay.scrollTop <= currentOverlay.clientHeight;
        }
    }
}

function isiOS() {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

if (isiOS()) {
    var menu = document.querySelectorAll('.mpopap-menu');
    initPreventIosScroll(menu);
}


function confirmDeleteByURL(action, name) {
    if (confirm(name) == true) {
        document.location.href = action;
    } else {
        return false;
    }
}

var widthElement = document.querySelectorAll('[data-event="ad-width"]')[0];

if (widthElement) {
    var widthads = widthElement.value;

    if (screen.width < 728 && widthads >= 728) {
        document.querySelector('.noindex-block:last .adsbygoogle').remove();
    } else {
        var adsbygoogle = window.adsbygoogle || [];
        adsbygoogle.push({});
    }
}

var eventElements = document.querySelectorAll('.event-desc');

for (i = 0; i < eventElements.length; ++i) {
    var text = eventElements[i].innerHTML;

    if (text.length > 200) {
        var len = 200;
        var dots = "<span style='display: block;'>&#8230;</span>";
        var charAtLen = text.substr(len, 1);

        while (len < text.length && !/\s/.test(charAtLen)) {
            len++;
            charAtLen = text.substr(len, 1);
        }

        var shown = text.substring(0, len) + dots;
        var hidden = '<span class="hidden" style="display:none;">' + text.substring(len, text.length) + '</span>';
        eventElements[i].innerHTML = shown + hidden;

        var moreBtn = document.createElement('div');
        moreBtn.innerHTML = 'Подробнее';
        moreBtn.classList.add('event-more');
        eventElements[i].appendChild(moreBtn);

        moreBtn.addEventListener('click', function () {
            this.classList.toggle('turn');

            if (this.classList.contains('turn')) {
                this.textContent = 'Свернуть';
                this.parentElement.querySelector('span:not(.hidden)').style.display = 'none';
                this.parentElement.querySelector('span.hidden').style.display = 'block';
            } else {
                this.textContent = 'Подробнее';
                this.parentElement.querySelector('span:not(.hidden)').style.display = 'block';
                this.parentElement.querySelector('span.hidden').style.display = 'none';
            }
        });
    }
}
